<markant-platform-table
  *ngIf="tableParams$ | async as tableParams"
  class="usage-information-table"
  [data]="tableData$ | async"
  [defaultHeaderCells]="tableDraft.headerAndTableCells"
  [totalCount]="totalCount"
  [pageIndex]="tableParams.page.index"
  [pageSize]="tableParams.page.size"
  [showPagination]="true"
  (indexChanged)="onIndexChange($event)"
  (pageSizeChanged)="onPageSizeChange($event)"
></markant-platform-table>
